var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMusicNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.002 20.997V7.366a3.2 3.2 0 0 1 2.186-3.036l11.784-3.272a1.6 1.6 0 0 1 2.026 1.541v13.599",
    stroke: "url(#paint0_linear_437_16203)",
    strokeWidth: 1.869,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.002 9.499 25 4.699",
    stroke: "url(#paint1_linear_437_16203)",
    strokeWidth: 1.869,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 20.995a4 4 0 1 0 8 0 4 4 0 0 0-8 0Z",
    fill: "url(#paint2_linear_437_16203)",
    stroke: "url(#paint3_linear_437_16203)",
    strokeWidth: 1.869,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.997 16.198a4 4 0 1 0 8 0 4 4 0 0 0-8 0Z",
    fill: "url(#paint4_linear_437_16203)",
    stroke: "url(#paint5_linear_437_16203)",
    strokeWidth: 1.869,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_437_16203",
    x1: 12.998,
    y1: 1.556,
    x2: 23.771,
    y2: 5.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7890C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B19DD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_437_16203",
    x1: 12.998,
    y1: 4.833,
    x2: 16.288,
    y2: 10.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7890C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B19DD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_437_16203",
    x1: 2.998,
    y1: 17.217,
    x2: 7.995,
    y2: 19.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7890C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B19DD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_437_16203",
    x1: 2.998,
    y1: 17.217,
    x2: 7.995,
    y2: 19.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7890C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B19DD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_437_16203",
    x1: 18.995,
    y1: 12.421,
    x2: 23.992,
    y2: 14.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7890C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B19DD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_437_16203",
    x1: 18.995,
    y1: 12.421,
    x2: 23.992,
    y2: 14.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7890C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B19DD0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicNote);
export default __webpack_public_path__ + "static/media/musicNote.f4d149f3b899483bb9ed17bbd2077f8e.svg";
export { ForwardRef as ReactComponent };